import { useEffect, useState } from 'react';

import { Dashboard, Visibility, AccountBalance, History } from '@mui/icons-material';
import { Badge, BottomNavigation, BottomNavigationAction, Paper, useMediaQuery, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppSelector } from '../../store/hooks';

export default function QuickMobileNav() {
  const theme = useTheme();
  const isTabletSize = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(location.pathname);
  const { priceAlerts } = useAppSelector((gs) => gs.priceAlertState);

  function normalizePath(pathname: string) {
    // Treat root as dashboard
    if (pathname === '/' || pathname === '') return '/dashboard';
    return pathname;
  }

  useEffect(() => {
    setValue(normalizePath(location.pathname));
  }, [location.pathname]);

  if (!isTabletSize) return null;

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1300
      }}
      elevation={8}
    >
      <BottomNavigation
        value={value}
        onChange={(_, newValue) => {
          setValue(newValue);
          navigate(newValue);
        }}
        showLabels
      >
        <BottomNavigationAction label="Dashboard" value="/dashboard" icon={<Dashboard />} />
        <BottomNavigationAction
          label="Watchlist"
          value="/watchlist"
          icon={
            <Badge badgeContent={priceAlerts.length} color="error" variant="dot">
              <Visibility />
            </Badge>
          }
        />
        <BottomNavigationAction label="Securities" value="/securities" icon={<AccountBalance />} />
        <BottomNavigationAction label="History" value="/history" icon={<History />} />
      </BottomNavigation>
    </Paper>
  );
}
